import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarModule } from 'primeng/sidebar';
import { DividerModule } from 'primeng/divider';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { AzureService } from 'src/app/core/auth/azure.service';
import { Subject, takeUntil } from 'rxjs';
import { User } from 'src/app/shared/models/user.model';
import { PricingService } from 'src/app/features/pricing-history/services/pricing.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-sidebar',
  template: `
  <p-sidebar [(visible)]="sidebarVisible" styleClass="w-30rem" [dismissible]="true" position="right" [showCloseIcon]="false">
  <ng-template pTemplate="header"><span class="text-title">  Profile </span></ng-template>
    <ng-template pTemplate="content">
      <div class="user-details-container">
        <span class="text-default-strong-bold">User Name</span>
        <span class="text-small-roman">
        {{ currentUser?.displayName }}
        </span>
        <span class="text-small-roman">
          last update: {{ lastUpdateOn }}
        </span>
      </div>
      <p-divider></p-divider>
    </ng-template>
    <ng-template pTemplate="footer">
      <p-divider></p-divider>
      <div class="logout-container">
        <span class="text-default-strong-bold">Log out</span>
       <a href="" (click)="logout()">
       <img src="assets/images/logout.svg" alt="logout">
       </a>
      </div>
    </ng-template>
    </p-sidebar>
  `,
  styles: `
    .user-details-container {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      gap: 1.41rem;
    }
    .logout-container {
      display: flex;
      justify-content: space-between;
    }
  `,
  standalone: true,
  imports: [CommonModule, SidebarModule, DividerModule],
})
export class SidebarComponent implements OnInit, OnDestroy {
  currentUser: User | null = null;
  sidebarVisible = false;
  lastUpdateOn = ''

  private readonly _destroying$ = new Subject<void>();
  private navigationService = inject(NavigationService);
  private azureService = inject(AzureService);
  private pricingService = inject(PricingService)
  private messageService = inject(MessageService)

  ngOnInit(): void {
    this.navigationService.sidebarVisible.pipe(takeUntil(this._destroying$))
    .subscribe(visible => this.sidebarVisible = visible);

    this.azureService.getUserInfo().pipe(takeUntil(this._destroying$)).subscribe();

    this.azureService.getCurrentUser().pipe(takeUntil(this._destroying$)).subscribe(userData => {
      this.currentUser = userData;
    });

    this.getLastUpdatedDate()

  }

  logout() {
    this.azureService.logout();
  }

  getLastUpdatedDate() {
    this.pricingService
      .getLastUpdatedDate()
      .pipe()
      .subscribe({
        next: (result: any) => {
          this.lastUpdateOn = result['month_last_updated']
        },
        error: (e) => {
          console.log(e)
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'There is some error while fetching last updated info.',
          })
        },
      })
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
